/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 10:42:58 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 16:48:26
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.about.h1') }}</h1>
      <h2>{{ st('helpDocs.about.h2What') }}</h2>
      <p>{{ st('helpDocs.about.pWhat1') }}</p>
      <p>{{ st('helpDocs.about.pWhat2') }}</p>
      <p>{{ st('helpDocs.about.pWhat3') }}</p>
      <h2>{{ st('helpDocs.about.h2How') }}</h2>
      <p>{{ st('helpDocs.about.pHow1') }}</p>
      <p>{{ st('helpDocs.about.pHow2') }}</p>
      <h2>{{ st('helpDocs.about.h2Who') }}</h2>
      <ul>
        <li>{{ st('helpDocs.about.liWho1') }}</li>
        <li>{{ st('helpDocs.about.liWho2') }}</li>
      </ul>
      <h2>{{ st('helpDocs.about.h2Why') }}</h2>
      <ul>
        <li>{{ st('helpDocs.about.liWhy1') }}</li>
        <li>{{ st('helpDocs.about.liWhy2') }}</li>
        <li>{{ st('helpDocs.about.liWhy3') }}</li>
      </ul>
      <p>{{ st('helpDocs.about.pPartner') }}</p>
      <a
        target="_blank"
        href="https://advertising.amazon.com/partners/directory/details/amzn1.ads1.ma1.8c07np6d41a2acho49ywwl4bu/Artemis-Ads-LLC"
        >{{ st('helpDocs.about.aPartner') }}</a>
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
